import { createSlice } from '@reduxjs/toolkit';
import { TRAVEL_MODES } from '../../constants';

const initialState = {
  data: {
    travelMode: TRAVEL_MODES[0],
    origin: {},
    destinations: [],
    routes: {},
    error: '',
  },
};

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setData(state, action) {
      state.data = {
        ...state.data,
        ...action.payload,
      };
    },
    addDestination(state, action) {
      state.data.destinations.push(action.payload);
    },
    removeDestination(state, action) {
      state.data.destinations = state.data.destinations.filter((_, index) => index !== action.payload);
      state.data.routes = {};
    },
  },
});

export const { setData, addDestination, removeDestination } = mapSlice.actions;
export default mapSlice.reducer;
